import { render, staticRenderFns } from "./courseCartPaymentPlans.vue?vue&type=template&id=79f93f1c&scoped=true&"
import script from "./courseCartPaymentPlans.vue?vue&type=script&lang=js&"
export * from "./courseCartPaymentPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f93f1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
